import { Component, Inject, Injector, ViewEncapsulation } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { MatDialog } from "@angular/material/dialog";
import { ViewerConfigurationService } from "../../viewer-components/services/viewer-configuration.service";
import { WmsLayerComponent } from "./wms-layer.component";
import { PhoenixWmsLayerResultsDialogComponent } from "../wms-layer-results-dialog/phoenix-wms-layer-results-dialog.component";
import { VIEWER_SERVICE } from "../../viewer-components/services/internal-services/viewer-services/inject-base-viewer.service";
import { BaseViewerService } from "../../viewer-components/services/internal-services/viewer-services/base-viewer.service";

@Component({
  selector: "phoenix-wms-component",
  templateUrl: "./wms-layer.component.html",
  styleUrls: ["./wms-layer.component.scss"],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class PhoenixWmsLayerComponent extends WmsLayerComponent {
  constructor(
    http: HttpClient,
    viewerConfigurationService: ViewerConfigurationService,
    matDialog: MatDialog,
    private injector: Injector,
    @Inject(VIEWER_SERVICE) public viewerService: BaseViewerService,
  ) {
    super(http, viewerConfigurationService, matDialog);
  }

  loadLayers() {
    const dialog = this.matDialog.open(PhoenixWmsLayerResultsDialogComponent, {
      data: {
        viewerService: this.viewerService,
        url: this.url,
        username: this.form.get("username").value,
        password: this.form.get("password").value,
        layers: this.layers,
        isAuthRequired: this.isAuthRequired,
      },
      panelClass: "medium-panel-dialog",
      autoFocus: false,
      injector: this.injector,
    });
    dialog.afterClosed().subscribe(() => {
      this.isLoading = false;
      this.cdr.detectChanges();
      document.getElementById("lblError").innerHTML = "";
    });
  }

  getWMSFormatter() {
    return this.viewerService.getCoreMap().getWMSFormatter();
  }
}
